import * as yup from 'yup';

export const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email().required('Please enter your email')
});

export const loginSchema = yup.object().shape({
  email: yup.string().required('Please enter your username or email'),
  password: yup.string().required('Please enter your password')
});

export const emailInputAITeamRating = yup.object().shape({
  email: yup.string().required('Please enter your email')
});

export const ChangePasswordSchema = yup.object().shape({
  code: yup.string().required('Please enter the code found in your email'),
  email: yup.string().required('Please enter your email'),
  password: yup
    .string()
    .required('Please enter your password')
    .min(8, 'Password is too short - should contain 8 characters minimum')
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!#$%&*?@^-]).{8,}$/,
      'Password must contain a digit, upper case letter and special character'
    ),
  passwordConfirmation: yup
    .string()
    .required('Please confirm your password')
    .test(
      'match',
      'Passwords do not match', // your error message
      function () {
        return this.parent.password === this.parent.passwordConfirmation;
      }
    )
});

export const authenticatedCheckoutSchema = yup.object().shape({
  terms: yup
    .array()
    .required()
    .min(1, 'Please agree to the terms and conditions')
});

export const unAuthenticatedCheckoutSchema = yup.object().shape({
  email: yup.string().email().required('Please enter your email'),
  password: yup
    .string()
    .required('Please enter your password')
    .min(8, 'Password is too short - should contain 8 characters minimum')
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!#$%&*?@^-]).{8,}$/,
      'Password must contain a digit, upper case letter and special character'
    ),
  passwordConfirmation: yup
    .string()
    .required('Please confirm your password')
    .test(
      'match',
      'Passwords do not match', // your error message
      function () {
        return this.parent.password === this.parent.passwordConfirmation;
      }
    ),
  terms: yup
    .array()
    .required()
    .min(1, 'Please agree to the terms and conditions')
});
